import script from "./UCGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./UCGrid.vue?vue&type=script&setup=true&lang=js"

import "./UCGrid.vue?vue&type=style&index=0&id=b0d189ec&lang=css"

const __exports__ = script;

export default __exports__